<template>
  <v-app>
  <div class="bannerNotif" :class="mode == 'maintenance' ? 'maintenance' : mode == 'support-withdrawn' ? 'supportWithdraw' : 'preLive'" v-if="bannerShow == true">{{bannerMsg}}</div>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import VueCookie from 'vue-cookie'
import HTTP from '@/services/http-request-handler'

export default {
  name: 'App',
  data () {
    return {
      bannerShow: false,
      bannerMsg: '',
      mode: ''
    }
  },
  created () {
     this.$store.dispatch('ACTION_FETCH_BANNER_MODES').then(res => {
     if(res && res.length) {
       res.forEach(x => {
       if(x.status == 1){
        this.bannerMsg =  x.text
        this.bannerShow = true 
        this.mode = x.mode
       }})}
    })
    /* eslint-disable */
    let accessToken = VueCookie.get('access-token')
    let accountType = VueCookie.get('account_type')
    if (window.location.pathname == '/document'){
    }
    else {   
    if (accessToken) {
      HTTP.defaults.headers['x-access-token'] = accessToken
      HTTP.get('/hola')
        .then(res => {
          if (res.status === 200 && res.data) {
            // eslint-disable-next-line
            if (accountType == 12 || accountType == 11) {
              window.location.replace('/admin/')
            } else {
              window.location.replace('/site/')
            }
          }
        })
        .catch(e => {
          if (e.response && e.response.status === 403) {
            let cookies = ['userCurrency', 'currency', 'access-token', 'x-access-token', 'account_state', 'account_type', 'resellerId', 'resellerCode']
            cookies.forEach(cookie => {
              VueCookie.delete(cookie)
            })
          }
        })
    }
    }
    let faviconElement = document.getElementById('favicon')
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'favicon.png' }).then(res => {
      let downloadFiles
      if (res && res !== null) {
        downloadFiles = 'data:image/png;base64,' + res
        faviconElement.href = downloadFiles
      } else {
        faviconElement.href = ''
      }
    })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', {directory: 'documents', document_type: 'webfont.woff', category: 'asssets'} ).then(res => {
      if (res) {
        // console.log('eav', res)
        let downloadFile = 'data:application/x-font-woff;charset=utf-8,' + res
        this.navLogo = downloadFile
        var styles = document.createElement('link')
        styles.rel = 'stylesheet'
        styles.type = 'text/css'
        styles.media = 'screen'
        styles.href = this.navLogo
        document.getElementsByTagName('head')[0].appendChild(styles)
        var font = document.createElement('style')
        font.type = 'text/css'
        document.getElementsByTagName('head')[0].appendChild(font)
        font.innerHTML = `
        @font-face {
          font-family: 'Open Sans';
          src: url(data:application/x-font-woff;charset=utf-8;base64,${res});
        }
        `
        document.head.appendChild(font)
      } else {
        this.navLogo = ''
      }
    })
    // this.$store.dispatch('ACTION_DOWNLOAD_LOGO', {directory: 'documents', document_type: 'icons.woff', category: 'asssets'}).then(res => {
    //   if (res) {
    //     console.log('icons', res)
    //     let downloadFile = 'data:application/x-font-woff;charset=utf-8,' + res
    //     this.navLogo = downloadFile
    //     var styles = document.createElement('link')
    //     styles.rel = 'stylesheet'
    //     styles.type = 'text/css'
    //     styles.media = 'screen'
    //     styles.href = this.navLogo
    //     document.getElementsByTagName('head')[0].appendChild(styles)

    //     var font = document.createElement('style')
    //     font.type = 'text/css'
    //     document.getElementsByTagName('head')[0].appendChild(font)
    //     font.innerHTML = `
    //     @font-face {
    //       font-family: 'Vodafone';
    //       src: url(data:application/x-font-woff;charset=utf-8;base64,${res});
    //     }
    //     `
    //     document.head.appendChild(font)
    //   } else {
    //     this.navLogo = ''
    //   }
    // })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', {directory: 'documents', document_type: 'colours.css', category: 'asssets'}).then(res => {
      if (res) {
        let downloadFile = 'data:text/css;base64,' + res
        this.navLogo = downloadFile
        var styles = document.createElement('link')
        styles.rel = 'stylesheet'
        styles.type = 'text/css'
        styles.media = 'screen'
        styles.href = this.navLogo
        document.getElementsByTagName('head')[0].appendChild(styles)
      }
    })
    // this.$store.dispatch('ACTION_DOWNLOAD_LOGO', {directory: 'documents', document_type: 'typography.css', category: 'asssets'}).then(res => {
    //   if (res) {
    //     let downloadFile = 'data:text/css;base64,' + res
    //     this.navLogo = downloadFile
    //     var styles = document.createElement('link')
    //     styles.rel = 'stylesheet'
    //     styles.type = 'text/css'
    //     styles.media = 'screen'
    //     styles.href = this.navLogo
    //     document.getElementsByTagName('head')[0].appendChild(styles)
    //   }
    // })
  }
}
</script>

<style lang="scss">
// @import 'assets/stylesheets/variables.scss';
@import 'assets/stylesheets/dictionary.scss';
@import 'assets/stylesheets/main.scss';
.over_x {
  overflow-x: hidden;
}
.application {
  font-family: "Open Sans" !important;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

::-webkit-scrollbar-track {
  border: none;
  background-color: #eee;
}

::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
  background-color: #cecece;
}
.bannerNotif {
  min-height: 64px;
  width: 100%;
  text-align: center;
  font-size: 18px;
  text-transform: uppercase;
  padding-top: 20px;
  padding-bottom: 10px;
  display: block;
  position: static;
}
.preLive {
  background: red;
  color: green;
}
.maintenance {
  background: yellow;
  color: black; 
}
.supportWithdraw {
  background: orange;
  color: white;
}
</style>
